import { Action, type CharacterManifest } from "@arena/shared";

/**
 * Dante Alighieri (docs/STANDARD_SPRITE.md, scheda di produzione): solemn,
 * a little haughty, fights with his book at medium range. S1 entangles the
 * one in front of him in the dark wood's branches (long stun, no push); S2
 * sends a line of fire flying ("Lasciate ogni speranza"). His Super Slam
 * opens the nine circles of Hell all around him.
 */
export const DANTE: CharacterManifest = {
  id: "dante",
  schemaVersion: 2,
  displayName: "Dante Alighieri",
  archetype: "zoner",
  description: "Il poeta dell’aldilà: libro, versi e picchiate. Virgilio evoca la Selva, un Malebranche carica col forcone. Suprema: I nove cerchi.",
  look: { build: "heavy", accent: "#c0392b" },
  stats: { speed: 45, power: 65, resistance: 60, weight: 55, range: 55, slamCharge: 50 },
  moveset: {
    light1: {
      name: "Terzina: schiaffo",
      startup: 3, active: 2, recovery: 8,
      range: 1.1, arcDeg: 110, knockback: 2.5, lift: 0, hitstun: 14, slamGain: 5, lunge: 3.5,
      cancelFrom: 5, nextLight: Action.Light2, superCancel: true, specialCancel: true,
    },
    light2: {
      name: "Terzina: falciata di pagine",
      startup: 3, active: 2, recovery: 9,
      range: 1.5, arcDeg: 150, knockback: 3, lift: 0, hitstun: 15, slamGain: 5, lunge: 3.5,
      cancelFrom: 5, nextLight: Action.Light3, superCancel: true, specialCancel: true,
    },
    light3: {
      name: "Terzina: montante del tomo",
      startup: 6, active: 2, recovery: 13,
      range: 1.6, arcDeg: 150, knockback: 9, lift: 7, hitstun: 23, slamGain: 10, lunge: 5,
      cancelFrom: 9, nextLight: Action.None, superCancel: true,
    },
    special1: {
      name: "Virgilio, pensaci tu",
      // Virgilio's selected area holds enemies in place (one-second anchor, no push).
      startup: 9, active: 4, recovery: 16,
      range: 1.5, arcDeg: 360, knockback: 0, lift: 0, hitstun: 30, slamGain: 8, lunge: 0, damage: 8,
      cancelFrom: 255, nextLight: Action.None, superCancel: true,
      cooldown: 180,
    },
    special2: {
      name: "I Malebranche",
      // A readable devil charge: slower flight, early launch, sixteen metres.
      startup: 6, active: 1, recovery: 16,
      range: 0, arcDeg: 360, knockback: 8, lift: 4, hitstun: 19, slamGain: 7, lunge: 0,
      cancelFrom: 255, nextLight: Action.None, superCancel: true,
      cooldown: 120,
      projectile: { speed: 10, lifetime: 48, radius: 0.65 },
    },
    superSlam: {
      name: "I nove cerchi",
      startup: 12, active: 1, recovery: 24, armorTicks: 12,
      range: 4.5, arcDeg: 360, knockback: 13.5, lift: 9, hitstun: 32, slamGain: 0, lunge: 0,
      cancelFrom: 255, nextLight: Action.None, superCancel: false,
    },
    airAttack: {
      name: "Piovono versi", startup: 5, active: 3, recovery: 12,
      range: 1.8, arcDeg: 360, knockback: 5, lift: 3, hitstun: 14, slamGain: 6, lunge: 0,
      cancelFrom: 9, nextLight: Action.None, superCancel: true, specialCancel: true, landingAttack: true,
    },
    dashAttack: {
      name: "Invettiva", startup: 3, active: 4, recovery: 12,
      range: 1.6, arcDeg: 100, knockback: 7, lift: 2, hitstun: 16, slamGain: 6, lunge: 8, travel: 10,
      cancelFrom: 10, nextLight: Action.None, superCancel: true, specialCancel: true,
    },
  },
};
